<template>
    <search-select v-bind="$attrs" :options="options" label="name" :loading="loading" placeholder="Выберите часовой пояс" :allow-empty="allowEmpty" v-on="listeners" @input="$emit('input', $event)">
        <template slot="option" slot-scope="scope">
            <div class="d-flex justify-content-between align-items-center flex-truncate">
                <div class="text-truncate">{{ scope.option.name }}</div>
                <div class="ml-1">{{ scope.option.utc }}</div>
            </div>
        </template>

        <template slot="singleLabel" slot-scope="scope">
            <div class="d-flex justify-content-between align-items-center flex-truncate">
                <div class="text-truncate">{{ scope.option.name }}</div>
                <div class="ml-1">{{ scope.option.utc }}</div>
            </div>
        </template>
    </search-select>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import SearchSelect from '@/components/Select'

const state = new Vue.observable({
    loaded: false,
    options: []
})

const fetchOptions = async () => {
    if (!state.loaded) {
        let response = await axios.get('api/reference/timezones')
        state.options = response.data
        state.loaded = true
    }
}

export default {
    components: {
        SearchSelect
    },

    inheritAttrs: false,

    props: {
        allowEmpty: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        options() {
            return state.options
        },

        loading() {
            return state.loaded === false
        },

        listeners() {
            const { input, ...listeners } = this.$listeners
            return listeners
        }
    },

    async created() {
        await fetchOptions()
    }
}
</script>
